import StopwatchPage from './StopwatchPage';

export default StopwatchPage;
